export default __webpack_public_path__ + "static/media/gestion_treso.92e4de48.jpg";